import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AuditLogEvents, IAuditLogMetadata, RydeUiUnit } from "@ryde/shared";

import { useAuditLogEventName } from "./use-audit-log-event-name";

export const useAuditLogMetadata = () => {
  const { t } = useTranslation();
  const { getEventName } = useAuditLogEventName();

  const getMetadataText = useMemo(
    () =>
      ({
        metadata,
        eventName,
        entity,
      }: {
        metadata?: IAuditLogMetadata;
        eventName: AuditLogEvents;
        entity?: RydeUiUnit;
      }) => {
        const username = metadata?.userName;
        let baseText = "";

        if (metadata?.isPushToSyncer) {
          baseText = t("auditLog.pushToSyncerLabel", {
            legacyOldId: metadata.syncerLegacyOldId ?? "",
            recordId: metadata.syncerNewSysRecordId ?? "",
          });
        } else if (metadata?.info) {
          baseText = metadata.info;
        } else {
          const action = getEventName(eventName).toLowerCase();
          baseText = entity ? `Entity ${entity} ${action}` : `Entity ${action}`;
        }

        if (username) {
          return `${baseText} by ${username}`;
        }

        return baseText;
      },
    [getEventName, t],
  );

  return { getMetadataText };
};
